
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[franchiseeSlug]/reviews",
      function () {
        return require("private-next-pages/[franchiseeSlug]/reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[franchiseeSlug]/reviews"])
      });
    }
  